<template>
  <div class="flex flex-col items-center gap-1.5">
    <div class="flex items-center gap-1.5">
      <!-- CB -->
      <svg class="h-5 w-auto" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#f3f4f6" stroke="#d1d5db" stroke-width="1"/>
        <text x="24" y="20" text-anchor="middle" font-size="12" font-weight="bold" fill="#374151" font-family="system-ui">CB</text>
      </svg>
      <!-- Visa -->
      <svg class="h-5 w-auto" viewBox="0 0 780 500" xmlns="http://www.w3.org/2000/svg">
        <rect width="780" height="500" rx="40" fill="#f3f4f6" stroke="#d1d5db" stroke-width="8"/>
        <path d="M489.8 143.1c-46.8 0-88.7 24.3-88.7 69.2 0 51.4 74.2 55 74.2 80.8 0 10.9-12.5 20.6-33.8 20.6-30.2 0-52.8-13.6-52.8-13.6l-9.7 45.3s26 11.5 60.6 11.5c51.2 0 91.5-25.5 91.5-71.1 0-54.4-74.5-57.8-74.5-81.8 0-8.5 10.2-17.9 31.5-17.9 24 0 43.5 9.9 43.5 9.9l9.5-43.7s-21.3-9.2-51.3-9.2zM61.3 146.4l-1.1 6.6s19.7 3.6 37.4 10.8c22.9 8.3 24.5 13.1 28.4 28l41.9 161.7h56.2l86.6-207.1h-56.1l-55.6 140.8-22.7-119.3c-2.1-13.7-12.6-21.5-25.5-21.5H61.3zm271.9 0l-44 207.1h53.5l43.8-207.1h-53.3zm298.3 0c-12.9 0-19.7 6.9-24.7 19l-78.4 188.1h56.1l10.8-31.4h68.3l6.6 31.4h49.5l-43.2-207.1h-45zm7.3 55.9l16.6 77.7h-44.5l27.9-77.7z" fill="#6b7280"/>
      </svg>
      <!-- Mastercard -->
      <svg class="h-5 w-auto" viewBox="0 0 780 500" xmlns="http://www.w3.org/2000/svg">
        <rect width="780" height="500" rx="40" fill="#f3f4f6" stroke="#d1d5db" stroke-width="8"/>
        <circle cx="310" cy="250" r="150" fill="#9ca3af"/>
        <circle cx="470" cy="250" r="150" fill="#6b7280"/>
        <path d="M390 131.5a149.5 149.5 0 000 237 149.5 149.5 0 000-237z" fill="#d1d5db"/>
      </svg>
      <!-- Amex -->
      <svg class="h-5 w-auto" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" rx="4" fill="#f3f4f6" stroke="#d1d5db" stroke-width="1"/>
        <text x="24" y="20" text-anchor="middle" font-size="8" font-weight="bold" fill="#374151" font-family="system-ui">AMEX</text>
      </svg>
      <!-- Apple Pay -->
      <svg class="h-5 w-auto" viewBox="0 0 65 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="65" height="32" rx="4" fill="#f3f4f6" stroke="#d1d5db" stroke-width="1"/>
        <path d="M17.7 10.5c-.5.6-1.2 1-2 1-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-.1 0 .8-.2 1.6-.7 2.2zm.7 1.1c-1.1-.1-2.1.6-2.6.6-.5 0-1.4-.6-2.2-.6-1.2 0-2.2.7-2.8 1.7-1.2 2.1-.3 5.1.8 6.8.6.8 1.2 1.7 2.1 1.7.9 0 1.2-.6 2.2-.6s1.3.6 2.2.6 1.5-.8 2.1-1.7c.6-.9.9-1.8.9-1.9 0 0-1.8-.7-1.8-2.7 0-1.7 1.4-2.5 1.4-2.5-.7-1.1-1.9-1.3-2.3-1.4z" fill="#374151"/>
        <text x="30" y="20" font-size="11" font-weight="600" fill="#374151" font-family="system-ui">Pay</text>
      </svg>
      <!-- Google Pay -->
      <svg class="h-5 w-auto" viewBox="0 0 65 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="65" height="32" rx="4" fill="#f3f4f6" stroke="#d1d5db" stroke-width="1"/>
        <text x="32.5" y="20" text-anchor="middle" font-size="11" font-weight="600" fill="#374151" font-family="system-ui">G Pay</text>
      </svg>
    </div>
    <div class="flex items-center gap-1 text-xs text-gray-400">
      <svg class="w-3 h-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
      Paiement sécurisé par Stripe
    </div>
  </div>
</template>
